import { translateBackend } from '@assets/i18n/config';
import type { Security } from '@ovComponents/3-pattern/securitiesSelectionTable/securitiesSelectionTable';

const SUPPORT_COLORS = [
  'supportOne',
  'supportTwo',
  'supportThree',
  'supportFour',
  'supportFive',
  'supportSix',
] as const;

const DEFAULT_COLOR = 'supportOne' as const;

const getAssetClassName = (sec: Security): string | undefined => {
  return (
    translateBackend(sec.financialProduct.primaryAssetClass?.translatedName) ||
    sec.financialProduct.primaryAssetClass?.name
  );
};

export const assignSecurityColors = (securities: Security[]): Security[] => {
  const seenAssetClasses = new Set<string>();
  const orderedAssetClasses = securities.reduce<string[]>((acc, sec) => {
    const assetClass = getAssetClassName(sec);
    if (assetClass && !seenAssetClasses.has(assetClass)) {
      seenAssetClasses.add(assetClass);
      acc.push(assetClass);
    }
    return acc;
  }, []);

  const colorMap = orderedAssetClasses.reduce<
    Record<string, (typeof SUPPORT_COLORS)[number]>
  >(
    (acc, assetClass, i) => ({
      ...acc,
      [assetClass]: SUPPORT_COLORS[i % SUPPORT_COLORS.length],
    }),
    {},
  );

  return securities.map((sec) => {
    const assetClass = getAssetClassName(sec);
    return {
      ...sec,
      color: assetClass ? colorMap[assetClass] : DEFAULT_COLOR,
    };
  });
};
